export default "Harberger Taxes <b>redistribute wealth</b>.\n";